import { useSearchParams } from 'next/navigation';

export const useShareToken = () => {
	const searchParams = useSearchParams();

	const shareToken = searchParams?.get('share_token');

	return shareToken;
};
